<template>
    <div class="bg-gray-50">
      <div class="w-full max-w-[1400px] mx-auto print-container">
        <div class="p-2 space-y-6">
          <!-- HEADER -->
          <router-link to="/student/result" class="hover:text-gray-800 flex items-center gap-4">
            <font-awesome-icon :icon="['fas', 'chevron-left']" class="text-2xl" />
            <p>go back</p>
          </router-link>
          <div class="p-2 flex items-center gap-56">
            <img v-if="school?.logo" :src="school.logo" class="w-28 h-28 object-contain" :alt="school?.name || 'School logo'" />
            <i v-else class="pi pi-graduation-cap text-primary" style="font-size: 5rem;"></i>
            <div class="text-center">
              <div class="space-y-1">
                <h2 class="font-bold text-5xl whitespace-nowrap border border-b-gray-300 pb-3">{{ school?.name }}</h2>
                <div class="border border-b-gray-300 pb-3">
                  <p class="text-3xl font-semibold">{{ school?.address }}</p>
                  <p class="text-lg whitespace-nowrap space-x-4 font-medium">
                    <span v-if="school?.website">Website: {{ school.website }}</span>
                    <span v-if="school?.mobile">Mobile: {{ school.mobile }}</span>
                    <span v-if="school?.email">Email: {{ school.email }}</span>
                  </p>
                </div>
                <h1 class="font-semibold text-3xl">
                  {{ currentUserSurname }} {{ currentUserFirstName }} {{ currentUserOtherName }} {{ selectedClassroom }}
                </h1>
              </div>
            </div>
          </div>
          <!-- DETAILS -->
          <StudentDetail />
          <!-- Print button -->
          <button class="bg-primary hover:bg-primary/90 text-white font-bold py-3 px-10 rounded" id="printButton" @click="printPage">
            Print
          </button>
          <!-- RESULT TABLE -->
          <ResultTable />
          <!-- GRADE SYSTEM -->
          <Grade />
          <!-- Comment -->
          <Comment :teacherRemark="teacherRemark" :principalRemark="principalRemark" />
        </div>
      </div>
    </div>
  </template>

<script setup lang="ts">
import { useUserStore } from '../../../store/userStore';
import { useSchoolQuery } from '@/composables/queries/useSchoolQuery';
import { LocalStorageKeys } from '@/constants/LocalStorageKey.constant';
import Comment from './Comment.vue';
import Grade from './Grade.vue';
import ResultTable from './ResultTable.vue';
import StudentDetail from './StudentDetails.vue';

const userStore = useUserStore();
const { school } = useSchoolQuery();

const printPage = () => {
  window.print();
};

// Hide print button for printing
window.onbeforeprint = function() {
  document.getElementById('printButton').classList.add('hidden');
};

// Show print button after printing
window.onafterprint = function() {
  document.getElementById('printButton').classList.remove('hidden');
};

const currentUser = computed(() => userStore.currentUser);

const currentUserSurname = computed(() =>
  currentUser.value?.__typename === 'Student' ? currentUser.value.surname : '',
);
const currentUserFirstName = computed(() =>
  currentUser.value?.__typename === 'Student' ? currentUser.value.firstName : '',
);
const currentUserOtherName = computed(() =>
  currentUser.value?.__typename === 'Student' ? currentUser.value.otherName : '',
);

const selectedClassroom = localStorage.getItem(LocalStorageKeys.selectedClassroom);

const teacherRemark = ref(JSON.parse(localStorage.getItem(LocalStorageKeys.teacherRemark)));
const principalRemark = ref(JSON.parse(localStorage.getItem(LocalStorageKeys.principalRemark)));

onMounted(() => {
  userStore.getStudentSessions();
});
</script>

  <style scoped>
  @media print {
    @page {
      size: landscape;
    }
  }
  </style>

